import { createAsyncThunk } from '@reduxjs/toolkit';

/**
 * Fire-and-forget notification when the user clicks a retention offer
 * CTA inside the cancellation flow.
 */
const notifyRetentionOfferClicked = createAsyncThunk(
  'billing/notifyRetentionOfferClicked',
  async (
    payload,
    { extra: { sdk, Logger } },
  ) => {
    try {
      Logger.log('User', 'CancellationFlowRetentionOfferClicked', {
        offerType: payload?.retentionOfferShown,
        ctaType: payload?.ctaType,
        reasons: payload?.reasons,
      });

      await sdk.billing.notifyRetentionOfferClicked(payload);
      return { success: true };
    } catch (error) {
      Logger.error(
        new Error('Retention offer click notification failed'),
        { error },
        [
          'CancellationFlowRetentionClickFailed',
          {
            errorMessage: (error && error.message) || 'NoMessage',
            offerType: (payload && payload.retentionOfferShown) || 'unknown',
            ctaType: (payload && payload.ctaType) || 'unknown',
          },
        ],
      );
      return { success: false };
    }
  },
);

export default notifyRetentionOfferClicked;
